import React, { useEffect, useState } from "react";

export default function Faq() {
  const [activeFilter, setActiveFilter] = useState("all");
  const [expandedItems, setExpandedItems] = useState({
    donor1: true,
    nonprofit1: true,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Update expanded items when filter changes
  useEffect(() => {
    const newExpandedItems = { ...expandedItems };

    if (activeFilter === "all" || activeFilter === "donors") {
      newExpandedItems.donor1 = true;
    }

    if (activeFilter === "all" || activeFilter === "nonprofits") {
      newExpandedItems.nonprofit1 = true;
    }

    setExpandedItems(newExpandedItems);
  }, [activeFilter]);

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
  };

  const toggleItem = (id) => {
    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const donorFaqs = [
    {
      id: "donor1",
      question: "How can I help rescue animals on Sponsor a Pet?",
      answer: (
        <div className="!font-montserrat !font-normal !text-lg">
          <p className="mb-4 mt-8 !font-montserrat !text-base !font-medium">
            There are 3 ways on how you can help rescue animals on Sponsor a
            Pet:
          </p>
          <ol className="mb-4">
            <li className="mb-4">
              <p className="ml-1 !font-semibold !text-base !font-montserrat mb-4">
                1. Join the PetStar Club by donating monthly
              </p>
              <p className="!font-montserrat !text-base !font-medium ">
                Joining the PetStar Club affords you the opportunity to
                continually make an impact across multiple communities. Choose
                the amount that you're comfortable giving.
              </p>
            </li>
            <li className="mb-4">
              <p className="ml-1 !font-semibold !text-base !font-montserrat mb-4">
                2. Support individual non-profits or animal in need.
              </p>
              <p className="!font-montserrat !text-base !font-medium">
                You can support a non-profit or animal with a one time donation.
                Funds are sent directly to the non-profit that cares for the
                animal.
              </p>
            </li>
            <li className="mb-2">
              <p className="ml-1 !font-semibold !text-base !font-montserrat mb-4">
                3. Purchase our merchandise
              </p>
              <p className="!font-montserrat !text-base !font-medium">
                For every purchase made on our merchandise, a portion of the
                proceeds goes to one of our non-profit partners.
              </p>
            </li>
          </ol>
        </div>
      ),
    },
    {
      id: "donor2",
      question: "How can I be sure my donation is helping the pet I donate to?",
      answer:
        "All the organizations featured on Sponsor a Pet are certified 501(c) non-profits that have been vetted by us. After your donation, you will receive monthly updates regarding the nonprofit or the animal that you're sponsoring.",
    },
    {
      id: "donor3",
      question: "Does Sponsor a Pet work with international non-profits?",
      answer:
        "Yes, Sponsor a Pet works with international non-profits as animals that are in need and need or support does not stop at the boarders of the US. However, since they are international, these are not tax deductible donations. The PetStar club will only donate to certified 501(c)3 non-profits. International Non-profits will be on an individual basis.",
    },
    {
      id: "donor4",
      question: "How can I be more involved in the community?",
      answer:
        "We wholeheartedly believe that it takes the community to help bring change. Whether its online or working with your local nonprofit organization. Please feel free to reach out to us to tell us how you would like to get involved. We're always looking for volunteers to help save all the animals.",
    },
    {
      id: "donor5",
      question: "How do I obtain my donation receipt?",
      answer:
        "After each donation, a receipt is emailed to you. You can review all your donations in your user profile dashboard.",
    },
    {
      id: "donor6",
      question: "Can my donation be refunded?",
      answer:
        "In order to support the urgent needs of our non-profit partners, we process the donations as quickly as possible to get them in the hands of animals in need. Because of this, refunds are not possible.",
    },
  ];

  const nonprofitFaqs = [
    {
      id: "nonprofit1",
      question: "How can I help rescue animals on Sponsor a Pet?",
      answer: (
        <div className="!font-montserrat !font-normal">
          <p className="mb-4 !font-montserrat !text-base !font-medium">
            Sponsor a Pet fosters an environment of community online and an in
            person. We work closely with our non-profit partners and the
            individual members who are passionate about the wellbeing of all
            animals. Each non-profit works one on one with a dedicated
            fundraising consultant to discuss their goals and needs. Our
            automated tools function as the marketing arm of your organization
            while being able to reach Hundred of Thousands outside of your
            constituents.
          </p>
          <p className="!font-montserrat !text-base !font-medium">
            If you would like to discuss additional services to outsource we
            would be happy to discuss. In addition to our automation, we can
            help ensure your organization runs smoothly from an operations
            standpoint. Sponsor a Pet has a tremendous amount of first hand
            experience of managing the books, donor relationships, managing
            costs and making your organization more agile.
          </p>
        </div>
      ),
    },
    {
      id: "nonprofit2",
      question: "Does it cost anything to use Sponsor a Pet?",
      answer:
        "Sponsor a Pet is a completely free platform. We will feature your organization, animals in need, your stories for free across all of our platforms.",
    },
    {
      id: "nonprofit3",
      question: "How quickly will I receive my funds?",
      answer:
        "PayPal donation can be distributed on a weekly basis. Other donations are paid out on a bi-weekly basis. It is our top priority to get your funds in your possession as quickly as possible.",
    },
  ];

  const renderFaqs = (faqType) => {
    let faqs = faqType === "donors" ? donorFaqs : nonprofitFaqs;

    return faqs.map((faq) => (
      <div
        key={faq.id}
        className="mb-6 text-left border-b border-gray-200 pb-6"
      >
        <div
          className="flex justify-between items-center cursor-pointer"
          onClick={() => toggleItem(faq.id)}
        >
          <h2 className="!font-montserrat !text-lg !font-semibold">
            {faq.question}
          </h2>
          <span className="text-2xl">{expandedItems[faq.id] ? "−" : "+"}</span>
        </div>
        {expandedItems[faq.id] && (
          <div className="mt-4 !font-montserrat !text-base !font-medium">
            {faq.answer}
          </div>
        )}
      </div>
    ));
  };

  return (
    <div className="py-10 mt-36">
      <div className="max-w-7xl mx-auto mb-20 px-4 text-center">
        <h1 className="!text-4xl !font-poppins md:!text-5xl !font-medium mb-7 text-orange">
          Frequently Asked Questions
        </h1>
        <p className="max-w-3xl !font-montserrat !text-base !font-medium mx-auto mb-7">
          Have questions? We've got answers! Whether you're a donor looking to
          support animal rescues or a non-profit interested in fundraising, our
          FAQ covers everything you need to know.
        </p>

        <div className="flex flex-col md:flex-row justify-center gap-4 mb-10">
          <button
            className={`px-8 py-2 rounded-full !font-montserrat !text-xs !font-semibold border transition-all border-[#1B3A5D] shadow-xl ${
              activeFilter === "all"
                ? "bg-[#1B3A5D] text-white"
                : " hover:bg-gray-200 text-[#1B3A5D]"
            }`}
            onClick={() => handleFilterChange("all")}
          >
            All
          </button>
          <button
            className={`px-4 py-2 rounded-full !font-montserrat !text-xs !font-semibold transition-all border border-[#1B3A5D] shadow-xl ${
              activeFilter === "donors"
                ? "bg-[#1B3A5D] text-white"
                : " hover:bg-gray-100 text-[#1B3A5D]"
            }`}
            onClick={() => handleFilterChange("donors")}
          >
            For Donors
          </button>
          <button
            className={`px-4 py-2 rounded-full !font-montserrat !text-xs !font-semibold transition-all border border-[#1B3A5D] shadow-xl ${
              activeFilter === "nonprofits"
                ? "bg-[#1B3A5D] text-white"
                : " hover:bg-gray-100 text-[#1B3A5D]"
            }`}
            onClick={() => handleFilterChange("nonprofits")}
          >
            For Non-Profits
          </button>
        </div>
      </div>

      {/* FAQ content sections */}
      {(activeFilter === "all" || activeFilter === "donors") && (
        <div className="lg:px-20 px-8 xl:px-32 flex flex-col md:flex-row md:gap-16 gap-4 mb-10">
          <div className="!font-poppins !text-3xl !font-semibold text-blue md:w-[350px] text-center md:text-left mb-6 md:mb-0">
            {" "}
            For Donors
          </div>
          {/*FAQ Content*/}
          <div className="w-full">{renderFaqs("donors")}</div>
        </div>
      )}

      {(activeFilter === "all" || activeFilter === "nonprofits") && (
        <div className="lg:px-20 px-8 xl:px-32 flex flex-col md:flex-row md:gap-16 gap-4 mt-0 md:mt-10">
          <div className="!font-poppins !text-3xl !font-semibold text-blue md:w-[350px] text-center md:text-left mb-6 md:mb-0">
            {" "}
            For Non-Profits
          </div>
          {/*FAQ Content*/}
          <div className="w-full">{renderFaqs("nonprofits")}</div>
        </div>
      )}
    </div>
  );
}
